import { FileIcon, TemplatesIcon } from '@bp/ui-components';
import type { FC } from 'react';
import styles from './TeachingUnitsTree.module.scss';
import { TreeItemType } from './types';

type TeachingUnitsTreeDragPreviewProps = { text: string; type?: TreeItemType };

export const TeachingUnitsTreeDragPreview: FC<TeachingUnitsTreeDragPreviewProps> = ({ text, type }) => {
  return (
    <div className={styles['drag-preview']}>
      <div className={styles.icon}>
        {type === TreeItemType.teachingUnit ? (
          <FileIcon className='svg-icon white' />
        ) : (
          <TemplatesIcon className='svg-icon white mr-1' />
        )}
      </div>
      <div className={styles.text}>{text}</div>
    </div>
  );
};
